module.exports = __webpack_public_path__ + "img/thankyou.c5e7c9b3.svg";